import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W3',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M11.64 27.64C5.21 27.64 0 22.43 0 16S5.21 4.36 11.64 4.36c4.37 0 8.17 2.41 10.16 5.97.48-.08.97-.15 1.48-.15 4.82 0 8.73 3.91 8.73 8.73s-3.91 8.73-8.73 8.73H11.64zm11.63-2.91c3.21 0 5.82-2.61 5.82-5.82 0-3.21-2.61-5.82-5.82-5.82-1.16 0-2.24.35-3.15.94-.9-3.87-4.35-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73s3.91 8.73 8.73 8.73h11.63z" }
      })]
    );
  }
};